export default __webpack_public_path__ + "static/media/staff2.a094fe59.jpg";